import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { post } from '../api/api';
import { showToast } from '../components/utils/toast';
type LoginParams = {
  redirectUrl: string;
  authorizationCode: string;
  codeVerifier: string;
};
const login = async (params: LoginParams): Promise<{ expirationTime: number }> => {
  return post(API_URLS.LOGIN, params, { skipGlobalErrorHandler: true });
};

export const useLogin = (): UseMutationResult<
  { expirationTime: number },
  AxiosError<{ message?: string; type?: string }>,
  LoginParams
> => {
  const { setIsLoading } = useLoading();

  return useMutation({
    mutationFn: login,
    onMutate: () => {
      setIsLoading(true);
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message || error.message;
      showToast('error', errorMessage);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
